import React from 'react';
import { motion } from 'framer-motion';
interface InViewProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}

/** Gentle entrance when a section scrolls into view. */
export function InView({
  children,
  delay = 0,
  y = 18,
  className = ''
}: InViewProps) {
  return <motion.div initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    delay,
    duration: 0.65,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-266" data-mp="133qmlxg1hgj6">
      {children}
    </motion.div>;
}